import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { Slider } from 'primereact/slider';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function ConfigureSummaryModal() {
  const { modals, selectedItem, handleGenerateConfigureSummary } = useFileManagerContext();
  const { showConfigureSummaryModal, setShowConfigureSummaryModal } = modals;
  const [format, setFormat] = useState('narrative');
  const [length, setLength] = useState(25);

  const handleGenerate = () => {
    handleGenerateConfigureSummary({
      format,
      length,
      rowData: selectedItem,
    });
  };

  const formatLengthText = () => {
    return `${length}% of original`;
  };

  const handleFooter = () => {
    return (
      <div className="footer-btn">
        <Button label="Cancel" onClick={() => setShowConfigureSummaryModal(false)} className="p-button p-button-secondary outline mx-2" />
        <Button label="Generate Summary" onClick={handleGenerate} className="p-button p-button-secondary" />
      </div>
    );
  };

  return (
    <Dialog
      className="new-task-popup media-popup"
      visible={showConfigureSummaryModal}
      modal
      onHide={() => setShowConfigureSummaryModal(false)}
      closable={false}
      footer={handleFooter}
    >
      <div className="modal-heading F-size16 text-bold mb-4">Configure Summary</div>
      <div className="mb-4">
        <div className="mb-3">
          <label className="p-medium mb-2 d-block">Format</label>
          <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center">
              <RadioButton
                inputId="format-narrative"
                name="format"
                value="narrative"
                checked={format === 'narrative'}
                onChange={(e) => setFormat(e.value)}
              />
              <label htmlFor="format-narrative" className="ms-2 mb-0 cursor-pointer">
                Narrative
              </label>
            </div>
            <div className="d-flex align-items-center">
              <RadioButton
                inputId="format-bullet"
                name="format"
                value="bullet_points"
                checked={format === 'bullet_points'}
                onChange={(e) => setFormat(e.value)}
              />
              <label htmlFor="format-bullet" className="ms-2 mb-0 cursor-pointer">
                Bullet Points
              </label>
            </div>
          </div>
        </div>

        <div className="mb-3 mt-4">
          <label className="p-medium mb-2 d-block">Summary Length</label>
          <div className="mb-2">
            <span className="text-muted">{formatLengthText()}</span>
          </div>
          <Slider value={length} onChange={(e) => setLength(e.value)} min={5} max={50} step={1} className="w-100" />
          <div className="d-flex justify-content-between mt-2">
            <span className="text-hint">5% (Very Brief)</span>
            <span className="text-hint">25%</span>
            <span className="text-hint">50% (Very Descriptive)</span>
          </div>
        </div>
      </div>

      <div className="text-hint d-flex align-items-start">
        <i className="pi pi-info-circle me-2 mt-1"></i>
        Summaries take time to process. You can return to the files section for updates. The status indicator will show when your summary is
        ready.
      </div>
    </Dialog>
  );
}

export default ConfigureSummaryModal;
